import { render, staticRenderFns } from "./NotificationListSkeleton.vue?vue&type=template&id=dcfd6844&scoped=true"
import script from "./NotificationListSkeleton.vue?vue&type=script&lang=js"
export * from "./NotificationListSkeleton.vue?vue&type=script&lang=js"
import style0 from "./NotificationListSkeleton.vue?vue&type=style&index=0&id=dcfd6844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfd6844",
  null
  
)

export default component.exports